// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2obpF","buttons":"RemoveExpirationActionButtons_buttons__37Js4"};